import type { Coerced } from '@repo/types/Types';
import { format } from 'date-fns';
import { fixDateForTimezone } from './fixDateForTimezone';
import { isValid } from 'date-fns';

export function coerce<T>(value: T): Coerced<T> {
  if (value instanceof Date && isValid(value)) {
    const date = new Date(value);

    return format(fixDateForTimezone(date), 'yyyy-MM-dd') as Coerced<T>;
  }

  return value as Coerced<T>;
}
